export default "__VITE_ASSET__B_wi0MnX__"